import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore.js'
import { authService } from '../services/authService.js'

// 1. Impor logo di sini (Sesuaikan path folder dengan struktur proyek Anda)
import logoImage from '../assets/logo.jpeg'

function Login() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { login } = useAuthStore()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      console.log('Starting login...', { username })
      const response = await authService.login(username, password)
      console.log('Login response:', response.data)
      const { user, tokens } = response.data.data
      login(user, tokens)
      navigate('/')
    } catch (err) {
      console.error('Login error:', err)
      setError(err.response?.data?.message || 'Login gagal. Periksa kembali akun Anda.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="hold-transition login-page" style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div className="login-box shadow-lg">
        <div className="card card-outline card-primary" style={{ borderRadius: '15px', borderTop: '5px solid #007bff' }}>
          <div className="card-header text-center py-4">
            <h1 className="h1 mb-0" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {/* 2. Penggantian icon ke gambar logo */}
              <img 
                src={logoImage} 
                alt="Logo Koperasi" 
                className="mr-2"
                style={{ 
                  height: '1.2em',         // Menggunakan satuan 'em' agar otomatis seukuran dengan text h1
                  width: 'auto', 
                  verticalAlign: 'middle',
                  objectFit: 'contain'
                }} 
              />
              <b>Core </b>System
            </h1>
            <p className="text-muted mb-0 mt-2">Sistem Informasi Simpan Pinjam</p>
            <p className="text-muted mb-0 mt-2">K2SU</p>
          </div>
          <div className="card-body login-card-body" style={{ borderRadius: '0 0 15px 15px', padding: '30px' }}>
            <p className="login-box-msg font-weight-bold text-uppercase" style={{ fontSize: '0.9rem', color: '#666' }}>
              Silakan Masuk
            </p>
            
            {error && (
              <div className="alert alert-danger border-0 shadow-sm animate__animated animate__shakeX">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                {error}
                <button type="button" className="close" onClick={() => setError('')}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group mb-4">
                <label className="small font-weight-bold">Username</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Masukkan username"
                    value={username}
                    style={{ fontSize: '1rem', borderRight: 'none' }}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                  <div className="input-group-append">
                    <div className="input-group-text bg-white" style={{ borderLeft: 'none' }}>
                      <span className="fas fa-user text-muted"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group mb-4">
                <label className="small font-weight-bold">Password</label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control form-control-lg"
                    placeholder="Masukkan password"
                    value={password}
                    style={{ fontSize: '1rem', borderRight: 'none' }}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <div className="input-group-append" style={{ cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}>
                    <div className="input-group-text bg-white" style={{ borderLeft: 'none' }}>
                      <span className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-muted`}></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12">
                  <button 
                    type="submit" 
                    className="btn btn-primary btn-block btn-lg shadow-sm" 
                    disabled={loading}
                    style={{ borderRadius: '8px', fontWeight: '600', transition: 'all 0.3s' }}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm mr-2"></span>
                        Memproses...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-sign-in-alt mr-2"></i> Masuk Sekarang
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>

            
          </div>
          <div className="card-footer text-center bg-transparent border-0 pb-4">
            <small className="text-muted">&copy; 2026 Core System - CID</small>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login